// import debounce from 'lodash/debounce'

class WindowScroll {
    constructor() {
        
        this.callbacks = [];
        
        this.x = 0
        this.y = 0
        
        window.addEventListener('scroll', () => {
            this.setScroll()
        })
    }
    
    addListener(callback) {
        this.callbacks.push(callback)
    }
    
    removeListener(callback) {
        for (var i = 0; i < this.callbacks.length; i++) {
            if (callback === this.callbacks[i]) {
                this.callbacks.splice(i, 1)
            }
        }
    }

    setScroll() {
        this.x = window.pageXOffset
        this.y = window.pageYOffset
        
        for (var i = 0; i < this.callbacks.length; i++) {
            this.callbacks[i]()
        }
    }
}

const Scroll = new WindowScroll()
export default Scroll
